import { Component } from "@angular/core";
import { DoughnutChartData } from "../../data-visualization";
import {
  returnsActivityStats,
  returnsOffers,
  returnsOffersNameColumn,
  returnsOffersValueColumns,
  returnsOutcomesData,
  returnsOutcomesLegend,
  returnsProducts,
  returnsProductsNameColumn,
  returnsProductsValueColumns,
  returnsReasons,
  returnsReasonsNameColumn,
  returnsReasonsValueColumns,
  returnsTopCards,
} from "../../returns/returns.data";

@Component({
  selector: "app-returns-report",
  templateUrl: "./returns-report.component.html",
  styleUrls: ["./../../dashboard-section-v2.scss", "./../dashboard-report.component.scss"],
})
export class DashboardReturnsReportComponent {
  topCards = returnsTopCards;
  outcomesData: DoughnutChartData = returnsOutcomesData;
  outcomesLegend = returnsOutcomesLegend;
  activityStats = returnsActivityStats;
  reasons = returnsReasons;
  reasonsNameColumn = returnsReasonsNameColumn;
  reasonsValueColumns = returnsReasonsValueColumns;
  products = returnsProducts;
  productsNameColumn = returnsProductsNameColumn;
  productsValueColumns = returnsProductsValueColumns;
  offers = returnsOffers;
  offersNameColumn = returnsOffersNameColumn;
  offersValueColumns = returnsOffersValueColumns;

  constructor() {}
}
